import reducerRegistry from '@utils/redux/ReducerRegistry';

import reducer from './reducer';
import { MODULE_NAME } from './constants';

export default function registerCart() {
  reducerRegistry.register(MODULE_NAME, reducer);
}
